module.exports = require("@swa-ui/placements/src/LinkedImage/LinkedImage.module.scss");